import _ from 'lodash'
import type {CoreExportFormat} from '@wix/document-services-types'
import {decorationPlugins} from './decorations'
import type {DecorationPlugin, DecorationPluginFunction} from './types'

const packPlugins: DecorationPlugin[] = [...decorationPlugins]
const unpackPlugins: DecorationPlugin[] = _.reverse([...packPlugins])

const runPlugins = (
    plugins: DecorationPlugin[],
    componentExport: CoreExportFormat,
    getPluginFuncToRun: (plugin: DecorationPlugin) => DecorationPluginFunction | undefined
) => {
    for (const plugin of plugins) {
        const pluginFunc = getPluginFuncToRun(plugin)
        pluginFunc?.(componentExport)
    }
}

export const getPluginsRunner = (componentExport: CoreExportFormat) => ({
    pack: () => runPlugins(packPlugins, componentExport, p => p.pack),
    unpack: () => runPlugins(unpackPlugins, componentExport, p => p.unpack)
})
